import styled from "@emotion/styled";
import React from "react";

import { getChipColors, STATUS_VARIANTS, STATUS_COLORS } from "./consts";

// eslint-disable-next-line consistent-return
const theme = (variant, status, chipColor) => {
  switch (variant) {
    case STATUS_VARIANTS.TEXT:
      return {
        backgroundColor: "transparent",
        color: STATUS_COLORS[status],
        padding: "0"
      };
    case STATUS_VARIANTS.FILLED:
      return {
        ...getChipColors(status, chipColor),
        padding: "8px 12px"
      };
    case STATUS_VARIANTS.FILLED_SMALL:
      return {
        ...getChipColors(status, chipColor),
        padding: "8px"
      };
  }
};

const StyledStatus = styled.span`
  background-color: ${({ status, variant, chipColor }) => theme(variant, status, chipColor).backgroundColor};
  color: ${({ status, variant, chipColor }) => theme(variant, status, chipColor).color};
  padding: ${({ variant }) => theme(variant).padding};
  display: inline-block;
  width: fit-content;
  font-size: 12px;
  border-radius: 8px;
  line-height: 1;
  `;

const StatusChip = ({ status, variant = STATUS_VARIANTS.TEXT, testId, text, style, chipColor }) => (
  status ?
    <StyledStatus
      style={style}
      status={status}
      variant={variant}
      chipColor={chipColor}
      data-testid={testId}>
      {text || status}
    </StyledStatus> : null
);

export default StatusChip;
